import ReportWidget from './report-widget-model'
import {sectionEndpoint} from 'scoreboard/components/bootslide/object-selector-menu'
import i18n from 'scoreboard/components/i18n'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import ReportWizard from 'scoreboard/reports/wizard/reports-wizard'
import appDisplay from 'scoreboard/components/app-display'
import ReportDialogEditor from 'scoreboard/dashboards/widgets/report/report-dialog-editor'
import Report from 'scoreboard/reports/report'


function newReportWidget(report, reportSubtype) {
	return new ReportWidget({
		properties: {
			type: 'report',
			tablePadding: 'large',
			reportSubtype
		}
	}, { report })
}

const AddExistingReportOption = AddDomainObjectEndpoint.extend({
	add: function (reportTreeNode) {
		const report = new Report({ id: reportTreeNode.id })
		const widget = newReportWidget(report, reportTreeNode.subtype)

		createWob(this.canvas, widget, { fetchData: false }, this.bootslideMenu)
	},

	allowSelect: function (node) {
		if (!AddDomainObjectEndpoint.prototype.allowSelect.apply(this, arguments)) {
			return false
		}

		return node.type !== 'folder'
	}
})

function saved(bootslideMenu) {
	var label = 'report.common.existing'
	return {
		label: i18n.get(label),
		content: option('add-widget-report', label),
		contentEndpoint: sectionEndpoint(
			bootslideMenu, 'reports', AddExistingReportOption
		)
	}
}

function newReport(bootslideMenu) {
	return {
		label: i18n.get('report.common.new'),
		content: option('add-widget-new-report', i18n.get('report.common.new')),
		target: () => {
			const renderReport = (report, wizard) => {
				report.editing = true
				appDisplay.dialog(report.fetch(), () => {
					const reportEditor = new ReportDialogEditor({
						model: report
					})
					reportEditor.once('done', report => {
						report.editing = false
						const widget = newReportWidget(report, report.get('subtype'))
						createWob(bootslideMenu.canvas, widget, { fetchData: true }, bootslideMenu)
					})
					//#45651 close the dialog
					wizard.trigger('done', report)
					return reportEditor
				})
			}

			const wizard = new ReportWizard({onDone: renderReport})
			appDisplay.dialog(wizard)
		}
	}
}

export { AddExistingReportOption }
export { saved }
export { newReport }